setTimeout(() => {
    const productForm = document.querySelector('quick-add-drawer, .product.product-container');
    const observer = new MutationObserver((MutationList) => {
        const priceEle = productForm.querySelectorAll('[bss-b2b-product-id]');
        console.log(123);
        let checkAppliedCP = false;
        if (priceEle?.length && BSS_B2B.shopData?.customer?.id) {
            priceEle.forEach(ele => {
                ele.style.visibility = 'hidden';
            });
            setTimeout(() => {
                priceEle.forEach(ele => {
                    ele.style.visibility = 'visibility';
                });
            }, 1000)
        }
    });
    observer.observe(productForm, { attributes: true });
}, 500)

document.addEventListener("DOMContentLoaded", e => {
  setTimeout(e => {
    const NT = document.querySelector("#bss-b2b-net-term-button-wrapper");
    if(NT) {
      NT.style.visibility = 'visible';
    }
  }, 500);
})